import ActionsPopover from "@/components/ActionsPopOver/ActionsPopOver";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import DatasetTable, { datasetTableColumns } from "@/components/DatasetTable/DatasetTable";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import useTableStateUrl from "@/components/Table/hooks/useTableStateUrl";
import { Column } from "@/components/Table/Table";
import useAnalytics from "@/hooks/useAnalytics";
import { EcoInventDataset, ImpactDataset, useImpactDatasets } from "@/hooks/useEcoInventDatasets";
import DeleteEpdAction from "@/pages/impact_references/epd/DeleteEpdAction";
import { DeleteOutlined, EditOutlined, MoreOutlined, PlusOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { NavigateFunction, useNavigate } from "react-router-dom";
import DeleteCustomImpactReferenceAction from "./custom/CustomImpactReference/DeleteCustomImpactReferenceAction";

export const extraColumn = (
  navigate: NavigateFunction
): Column<ImpactDataset | EcoInventDataset> => {
  return {
    key: "actions",
    label: "Actions",
    minWidth: "80px",
    maxWidth: "80px",
    noLink: true,
    renderer: (reference) =>
      reference.dataset_type !== "agri_footprint" && (
        <ActionsPopover
          actions={
            reference.dataset_type === "epd" ? (
              <>
                <ActionsPopOverItem
                  onClick={() => {
                    navigate(`/impact_references/epd/${reference.id}`);
                  }}
                  icon={<EditOutlined />}
                >
                  Edit details
                </ActionsPopOverItem>
                <DeleteEpdAction id={reference.id}>
                  <ActionsPopOverItem
                    danger
                    icon={<DeleteOutlined />}
                  >
                    Delete
                  </ActionsPopOverItem>
                </DeleteEpdAction>
              </>
            ) : reference.dataset_type === "custom" ? (
              <>
                <ActionsPopOverItem
                  icon={<EditOutlined />}
                  onClick={() => {
                    navigate(`/impact_references/custom/${reference.id}`);
                  }}
                >
                  Edit details
                </ActionsPopOverItem>
                <DeleteCustomImpactReferenceAction id={reference.id}>
                  <ActionsPopOverItem
                    danger
                    icon={<DeleteOutlined />}
                  >
                    Delete
                  </ActionsPopOverItem>
                </DeleteCustomImpactReferenceAction>
              </>
            ) : reference.dataset_type === "eco_invent" ? (
              <>
                <ActionsPopOverItem
                  onClick={() => {
                    navigate(`/impact_references/custom/create/${reference.id}`);
                  }}
                  icon={<PlusOutlined />}
                >
                  Use for new custom impact reference
                </ActionsPopOverItem>
              </>
            ) : (
              <></>
            )
          }
        >
          <MoreOutlined />
        </ActionsPopover>
      ),
  };
};

export default function AllReferences() {
  const navigate = useNavigate();
  const analytics = useAnalytics();
  const column = extraColumn(navigate);

  const columns = [
    ...datasetTableColumns.filter((x) => x.key !== "dataset_type"),
    ...(column ? [column] : []),
  ];

  const { pagination, filter, search, sort, onSearchFilterSortPaginate } = useTableStateUrl({
    columns,
    defaultPagination: { page: 1, pageSize: 20 },
  });

  const { data, isLoading, isFetching } = useImpactDatasets({
    pagination,
    filter,
    search,
    sort,
  });

  analytics.track("All References Overview Viewed");

  return (
    <Flex
      vertical
      gap={16}
    >
      <PageHeader title={"Impact references"} />
      <div>
        <DatasetTable
          columns={columns}
          totalRows={data?.total_count}
          onSearchFilterSortPaginate={onSearchFilterSortPaginate}
          pagination={pagination}
          data={data?.datasets}
          filter={filter}
          search={search}
          sort={sort}
          loading={isLoading || isFetching}
          rowLink={(record) => `/impact_references/custom/${record.id}`}
        />
      </div>
    </Flex>
  );
}
